import { render, staticRenderFns } from "./GiftDetail.vue?vue&type=template&id=2a1d8154&scoped=true&lang=pug&"
import script from "./GiftDetail.vue?vue&type=script&lang=js&"
export * from "./GiftDetail.vue?vue&type=script&lang=js&"
import style0 from "./GiftDetail.vue?vue&type=style&index=0&id=2a1d8154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1d8154",
  null
  
)

export default component.exports